import { components } from "@certn/api/generated-schemas/applicant-portal";
import { Link } from "@certn/cascadia-react";
import { StepType } from "@certn/cascadia-react/components/stepper/ActivityStepper";
import { formatDate } from "@certn/utils";
import { Trans, useTranslation } from "react-i18next";

import { BaseCard } from "./BaseCard";

interface Props {
  caseInstance: components["schemas"]["CompleteCaseList"];
}

export function CompleteCard(props: Props) {
  const { caseInstance } = props;
  const { t } = useTranslation();

  const progressSteps: StepType[] = [];

  caseInstance.logs?.forEach(({ additional_data, timestamp }) => {
    if (additional_data?.event === "APPLICANT_SUBMITTED") {
      progressSteps.push({
        title: t("Submitted"),
        description:
          t("You submitted the application to Certn on ") +
          formatDate(timestamp, "PPP"),
        status: "COMPLETE",
      });
      progressSteps.push({
        title: t("Processing"),
        description:
          t("Certn sent the report to ") +
          caseInstance.customer_name +
          " " +
          formatDate(caseInstance.derived_checks_status_date, "PPP"),
        status: "COMPLETE",
      });
    }

    if (additional_data?.event === "CHECK_DISPUTED") {
      progressSteps.push({
        title: t("In dispute"),
        description: t("Completed") + " " + formatDate(timestamp, "PPP"),
        status: "COMPLETE",
      });
    }
  });

  progressSteps.push({
    title: t("Complete"),
    description: (
      <>
        <Trans>Completed</Trans>{" "}
        {formatDate(caseInstance.derived_checks_status_date, "PPP")}
        {!caseInstance.restrict_applicant_communications && (
          <>
            {" "}
            -{" "}
            <Link
              textColor="text-placeholder"
              linkStyle="monochrome"
              testID="view-report-link"
              href={`/report/${caseInstance.short_id}/`}
            >
              <Trans>View Report</Trans>
            </Link>
          </>
        )}
      </>
    ),
    status: "COMPLETE",
  });

  return (
    <BaseCard
      title={caseInstance.customer_name}
      type="complete"
      tagText={t("Complete")}
      statusText={
        <>
          <Trans>Completed</Trans>{" "}
          {formatDate(caseInstance.derived_checks_status_date, "PP")}
          {!caseInstance.restrict_applicant_communications && (
            <>
              {" "}
              -{" "}
              <Link
                linkStyle="monochrome"
                testID="view-report-link"
                href={`/report/${caseInstance.short_id}/`}
              >
                <Trans>View Report</Trans>
              </Link>
            </>
          )}
        </>
      }
      progressSteps={progressSteps}
      variant="historyCard"
      shortID={caseInstance.short_id}
    />
  );
}
